import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import configuratorReducer from './Reducers/Configurator/Reducer';
import uiReducer from './Reducers/Ui';
import offerRequestReducer from './Reducers/Offer';
import ContainerSetup from './Screens/ContainerSetup';
import ConfiguratorScreen from './Screens/ConfiguratorScreen';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: '',
  // local: 'http://localhost:11260',
  local: 'http://int.much-container.local',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  language: 'de_DE',
  locales: [{ code: 'de_DE', preferred: true }, { code: 'en_GB' }],
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    ItemOverview: ContainerSetup,
    Configurator: ConfiguratorScreen,
  },
  reducers: {
    configurator: configuratorReducer,
    ui: uiReducer,
    offer: offerRequestReducer,
  },
  defaultLoadIdentifier: 'containeranlage',
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
